module.exports = __webpack_public_path__ + "media/Shane Filan-Beautiful In White.7561f030.mp3";